// components/DateFilter.jsx
import {
  Popover, Radio, RadioGroup, FormControlLabel, Box
} from "@mui/material";
import dayjs from "dayjs";
import { useState, useEffect } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import CustomButton from "./elements/CustomButton/CustomButton";
import DatePickerCustom from "./elements/datePicker";
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';

export default function DateFilter({ onSelectRange }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [rangeType, setRangeType] = useState("last_30_days");
  const [startDate, setStartDate] = useState(dayjs().subtract(30, "day"));
  const [endDate, setEndDate] = useState(dayjs());

  // call default filter on mount
  useEffect(() => {
    onSelectRange({ type: "quick", label: "Last 30 Days", startDate, endDate });
  }, []);

  const handleOpen = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleQuickRange = (value) => {
    setRangeType(value);
    let start, end = dayjs();
    if (value === "last_7_days") {
      start = dayjs().subtract(7, "day");
    } else if (value === "last_30_days") {
      start = dayjs().subtract(30, "day");
    }
    setStartDate(start);
    setEndDate(end);
    onSelectRange({ type: "quick", label: value === "last_7_days" ? "Last 7 Days" : "Last 30 Days", startDate: start, endDate: end });
    handleClose();
  };

  const applyCustomRange = () => {
    onSelectRange({ type: "custom", startDate, endDate });
    handleClose();
  };

  return (
    <div>
      <div className="bg-[#fff] border border-[#CFDBE8] py-2 px-3 cursor-pointer rounded-xl text-[#4A739C]" onClick={handleOpen}>
        Date Range
        <FilterAltOutlinedIcon />
      </div>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Box className="p-4 min-w-[260px] space-y-2">
          <RadioGroup
            value={rangeType}
            onChange={(e) => {
              const value = e.target.value;
              setRangeType(value);
              if (value !== "custom") handleQuickRange(value);
            }}
          >
            <FormControlLabel value="last_7_days" control={<Radio />} label="Last 7 Days" />
            <FormControlLabel value="last_30_days" control={<Radio />} label="Last 30 Days" />
            <FormControlLabel value="custom" control={<Radio />} label="Custom" />
          </RadioGroup>

          {rangeType === "custom" && (
            <div className="space-y-3 border border-[#CFDBE8] rounded-xl px-3 pb-2 pt-3">
              <div className="space-x-2 flex w-[350px]">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePickerCustom value={startDate} onChange={setStartDate} height={35} placeholder="Start date" />
                  <DatePickerCustom value={endDate} onChange={setEndDate} height={35} placeholder="End date" />
                </LocalizationProvider>
              </div>
              <div className="flex justify-center gap-2">
                <CustomButton onClick={handleClose} customeClass="w-[80px] h-[30px] primary-custom-button">Cancel</CustomButton>
                <CustomButton onClick={applyCustomRange} customeClass="w-[80px] h-[30px] gradient-button">Apply</CustomButton>
              </div>
            </div>
          )}
        </Box>
      </Popover>
    </div>
  );
}
